export const shouldTrackEvents = () => {
  if (!import.meta.env.PROD) return false;
  const prodHosts = ['treatink.com', 'www.treatink.com'];
  return prodHosts.includes(window.location.hostname);
};